var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSumrisev5White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 151.9 40.6",
    style: {
      enableBackground: "new 0 0 151.9 40.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D70048;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visma_Sumrise",
    transform: "translate(-9.642 -22.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1751",
    transform: "translate(9.642 25.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1747"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    className: "st0",
    d: "M93.4,25.4c3.5,0.3,7.5,2.1,9.7,4.7c2.8,3.2,1.9,6.5-2.2,7.4c-4.1,0.7-9.7-1.3-12.5-4.6 c-2.2-2.5-2.2-5-0.1-6.5l11.4,8.4L93.4,25.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1749",
    transform: "translate(35.765 0.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    className: "st1",
    d: "M113.6,37.4l-1.5-5.7c-0.1-0.7-0.3-1.3-0.4-2.1l0,0c0,0.7-0.1,1.3-0.4,2.1l-1.5,5.6h-2.4 l3.2-11.9h1.9l3.5,11.9h-2.5C113.6,37.2,113.6,37.4,113.6,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    className: "st1",
    d: "M76,25.4l1.5,5.7c0.1,0.7,0.3,1.3,0.4,2.1l0,0c0-0.7,0.1-1.3,0.4-2.1l1.5-5.6h2.5l-3.4,11.9 H77l-3.5-11.9L76,25.4L76,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    className: "st1",
    d: "M86.1,25.4v11.9h-2.4V25.4C83.8,25.4,86.1,25.4,86.1,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    className: "st1",
    d: "M99.6,25.4l1.2,7.1l0,0l0.9-7.1h3.1l1.3,11.9h-2.4l-0.6-8.5l0,0l-0.3,2.9l-1,5.6H100 l-1.2-5.7L98.4,29v-0.3l0,0L98,37.2h-2.5l1-11.9L99.6,25.4L99.6,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    className: "st1",
    d: "M92,25.4c-0.4,0.3-0.7,0.7-0.9,1.3c-0.6,1.5,0,2.7,0.6,3.7c0,0.1,0.1,0.3,0.3,0.4 c1.3,2.2,1.8,3.8,0.9,6c0,0.1-0.3,0.4-0.3,0.4h-2.8c0.4-0.3,0.7-0.7,0.9-1.2c0.6-1.6-0.1-3.1-0.9-4.4c-0.9-1.8-1.8-3.4-0.9-5.7 c0.1-0.3,0.3-0.6,0.3-0.6L92,25.4L92,25.4z"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,24.6H1.1v-3.8H12c1.3,0,1.9-0.6,1.9-1.9V16c0-0.5-0.2-0.9-0.5-1.2s-0.7-0.5-1.2-0.6l-6.8-1 C2,12.6,0.2,10.8,0.2,7.7V6c0-3.8,1.9-5.7,5.7-5.7h11.3v3.8H5.9c-1,0-1.5,0.6-1.5,1.9v1.7c0,1,0.6,1.5,1.7,1.7l6.8,1 c3.5,0.5,5.2,2.4,5.2,5.5v2.9C18.1,22.7,16.1,24.6,12,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.5,24.6h-7.6c-3.8,0-5.8-1.9-5.8-5.8V0.3h4.2v18.5c0,1.3,0.5,1.9,1.6,1.9h7.6c1.1,0,1.6-0.6,1.6-1.9V0.3 h4.2v18.5C42.2,22.7,40.3,24.6,36.5,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77,24.6h-4.2V6.1c0-1.3-0.5-1.9-1.6-1.9H66c-1.1,0-1.6,0.6-1.6,1.9v18.5h-4.2V6.1c0-1.3-0.5-1.9-1.6-1.9h-5.3 c-1.1,0-1.6,0.6-1.6,1.9v18.5h-4.2V6.1c0-3.8,1.9-5.8,5.8-5.8h5.3c0.7,0,1.4,0.2,2.1,0.6c0.7,0.4,1.2,0.9,1.6,1.5 c0.3-0.6,0.8-1.1,1.5-1.5s1.4-0.6,2.2-0.6h5.3c3.8,0,5.8,1.9,5.8,5.8v18.5H77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.6,24.6h-4.2V6c0-3.8,1.9-5.7,5.8-5.7h7v3.8h-7c-1,0-1.6,0.6-1.6,1.8C86.6,5.9,86.6,24.6,86.6,24.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 0.3,
    className: "st1",
    width: 4.2,
    height: 24.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.6,24.6h-10.9v-3.8h10.9c1.3,0,1.9-0.6,1.9-1.9V16c0-0.5-0.2-0.9-0.5-1.2s-0.7-0.5-1.2-0.6l-6.8-1 c-3.5-0.5-5.2-2.4-5.2-5.4V6c0-3.8,1.9-5.7,5.7-5.7h11.3v3.8h-11.3c-1,0-1.6,0.6-1.6,1.8v1.7c0,1,0.6,1.5,1.7,1.7l6.8,1 c3.5,0.5,5.2,2.4,5.2,5.5v2.9C127.6,22.7,125.6,24.6,121.6,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.6,24.6h-12.2c-3.8,0-5.8-1.9-5.8-5.8V6.1c0-3.8,1.9-5.8,5.8-5.8h7.6c3.9,0,5.8,1.9,5.8,5.8v2.6 c0,1.6-0.4,2.7-1.3,3.4c-0.9,0.6-2.3,1.1-4.4,1.4l-9.3,1.4v4c0,1.3,0.5,1.9,1.6,1.9h12.2L150.6,24.6L150.6,24.6z M147.6,8.5V6.1 c0-1.3-0.5-1.9-1.6-1.9h-7.6c-1.1,0-1.6,0.6-1.6,1.9v5l9.1-1.4C147,9.4,147.6,9.1,147.6,8.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.1,34h-1.3c-0.6,0-1-0.3-1-1v-4.7h0.7v1.6H76c0.6,0,1,0.3,1,1V33C77.1,33.6,76.8,34,76.1,34z M76.4,33v-2.1 c0-0.2-0.1-0.3-0.3-0.3h-1.5V33c0,0.2,0.1,0.3,0.3,0.3h1.3C76.3,33.3,76.4,33.2,76.4,33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.2,35.7h-2V35h2c0.2,0,0.3-0.1,0.3-0.3V34H79c-0.6,0-1-0.3-1-1v-3.1h0.7V33c0,0.2,0.1,0.3,0.3,0.3h1.5v-3.4 h0.7v4.9c0,0.3-0.1,0.5-0.2,0.7C80.8,35.6,80.6,35.7,80.2,35.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumrisev5White);
export default __webpack_public_path__ + "static/media/sumrisev5-white.6d43f956106719a3970146d9a5042dde.svg";
export { ForwardRef as ReactComponent };